import { SimpleRestModel } from 'lib/services';
import { HttpApi } from 'services';

export const RestaurantImageModel = SimpleRestModel({
  collectionName: 'restaurantsImages',
  HttpApi,
  getApiPath: (payload, action: string) => {
    switch (action) {
      case 'loadCollection':
      case 'createItem':
      default:
        return `restaurants/${payload.restaurantId}/images/`;
      case 'loadItem':
      case 'updateItem':
      case 'deleteItem':
        return `restaurants/${payload.restaurantId}/images/${payload.id}/`;
      case 'customCollectionAction':
        return `restaurants/${payload.restaurantId}/images/${payload.action}/`;
      case 'customItemAction':
        return `restaurants/${payload.restaurantId}/images/${payload.id}/${payload.action}/`;
    }
  },
});
